<script lang="ts" setup>
import { DateSpan } from '#Common/models'

const props = defineProps<{
  modelValue?: string | null
  nullable?: boolean
  optional?: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string | null | undefined]
}>()

const internalValue = ref(
  DateSpan.createFromFormattedString(props.modelValue || ''),
)

watch(
  () => props.modelValue,
  (newValue, oldValue) => {
    if (newValue === oldValue) {
      return
    }
    internalValue.value.formatted = newValue || ''
  },
)

watch(
  internalValue,
  (v) => {
    const val = v.isZero
      ? props.nullable
        ? null
        : props.optional
          ? undefined
          : ''
      : v.formatted
    emit('update:modelValue', val)
  },
  { deep: true },
)
</script>

<template>
  <UFieldGroup>
    <UInputNumber
      v-model="internalValue.days"
      :decrement="false"
      :min="0"
      :disabled="props.disabled"
    >
      <template #increment>
        <span class="text-muted" @click.stop>дней</span>
      </template>
    </UInputNumber>
    <UInputNumber
      v-model="internalValue.hours"
      :decrement="false"
      :min="0"
      :max="23"
      :disabled="props.disabled"
    >
      <template #increment>
        <span class="text-muted" @click.stop>часов</span>
      </template>
    </UInputNumber>
    <UInputNumber
      v-model="internalValue.minutes"
      :decrement="false"
      :min="0"
      :max="59"
      :disabled="props.disabled"
    >
      <template #increment>
        <span class="text-muted" @click.stop>минут</span>
      </template>
    </UInputNumber>
    <UInputNumber
      v-model="internalValue.seconds"
      :decrement="false"
      :min="0"
      :max="59"
      :disabled="props.disabled"
    >
      <template #increment>
        <span class="text-muted" @click.stop>секунд</span>
      </template>
    </UInputNumber>
  </UFieldGroup>
</template>
